import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eye } from 'lucide-react';
export function OnlineViewers() {
  const [count, setCount] = useState(() => Math.floor(Math.random() * 8) + 7); // 7–14
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => {
        // Random change: -2 to +3, clamped between 3 and 19
        const delta = Math.floor(Math.random() * 6) - 2;
        const next = prev + delta;
        return Math.max(3, Math.min(19, next));
      });
    }, 20000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed bottom-6 right-6 z-40" data-id="element-250">
      <div className="glass-card px-3.5 py-2 flex items-center gap-2 shadow-[0_0_20px_rgba(0,0,0,0.4)]" data-id="element-251">
        <span className="relative flex h-2 w-2" data-id="element-252">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-253" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" data-id="element-254" />
        </span>
        <Eye size={13} className="text-gray-400" data-id="element-255" />
        <AnimatePresence mode="wait" data-id="element-256">
          <motion.span key={count} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.3
        }} className="text-white text-xs font-semibold tabular-nums" data-id="element-257">
            {count}
          </motion.span>
        </AnimatePresence>
        <span className="text-gray-400 text-[11px]" data-id="element-258">viendo ahora</span>
      </div>
    </div>;
}